{
  "CSAT": {
    "TITLE": "Arvioi keskustelusi",
    "PLACEHOLDER": "Kerro meille lisää...",
    "RATINGS": {
      "POOR": "😞 Heikko",
      "FAIR": "😑 Kohtalainen",
      "AVERAGE": "😐 Keskinkertainen",
      "GOOD": "😀 Hyvä",
      "EXCELLENT": "😍 Erinomainen"
    }
  }
}
